export default "./dist/stdassets/images/icons/pan-south.png";